module.exports = __webpack_public_path__ + "img/sushiganzoben.51652910.jpg";